<template>
  <div :class="[$style.wrapper, double && $style.double]">
    <div v-if="title" :class="[$style.title, 'display-h3', 'form-group-title']">
      {{title}}
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'VFormGroup',
  props: {
    title: {
      type: String,
      default: null,
    },
    double: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" module src="./style.scss"></style>
